import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../api";
import { OrgAccessRequest } from "../../generated/core-api";

export function useGrantOrgAccess() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: OrgAccessRequest) => api.grantOrgAccess(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["user-admin", "users"] });
    },
  });
}
